import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import GoogleMapComponent from "./map.js";

const App = () => {
  const [locations, setLocations] = useState([]);

  const [loading, setLoading] = useState(true);

  const locationId = document
    .querySelector(".flexi-layout")
    .getAttribute("data-history-node-id");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/rest/locations`);
        const result = await response.json();

        let filteredLocations = result;
        if (locationId === "29124") {
          filteredLocations = result.filter(
            (item) => item.field_location === "San Francisco"
          );
        } else {
          filteredLocations = result.filter(
            (item) => item.field_location === "New York"
          );
        }

        setLocations(filteredLocations);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {!loading ? (
        <GoogleMapComponent
          locations={locations}
          locationId={locationId}
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=AIzaSyCotTmlZGNO7fU4UeN287SZeKi9oS2N2Vg&v=3.exp&libraries=geometry,drawing,places`}
          loadingElement={<div style={{ height: "100%" }} />}
          containerElement={<div style={{ height: "660px" }} />}
          mapElement={<div style={{ height: "100%" }} />}
        />
      ) : (
        <div className="react-loader">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </>
  );
};

export default App;

const rootElement = document.querySelector(".js-google-map");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
